module.exports = __webpack_public_path__ + "img/icon_order_on.6c829a55.svg";